import { Experiment } from 'types/shopConfig'
import { DEFAULT_VARIANT_NAME } from 'shared/experiments/consts/variants'

export const DEFAULT_EXPERIMENT: Partial<Experiment> = {
  variant: DEFAULT_VARIANT_NAME,
  isEnabled: false,
  active: false,
  variables: {}
}
